"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.closeModal = exports.openModal = exports.InteractionActionTypes = void 0;

var _namespacedKeyMirror = _interopRequireDefault(require("settings-ui-lib/utils/namespacedKeyMirror"));

var _fluxActions = require("flux-actions");

var InteractionActionTypes = (0, _namespacedKeyMirror.default)({
  OPEN_MODAL: null,
  CLOSE_MODAL: null
}, 'analytics-and-tracking');
exports.InteractionActionTypes = InteractionActionTypes;
var openModal = (0, _fluxActions.createAction)(InteractionActionTypes.OPEN_MODAL, function (modal) {
  return modal;
});
exports.openModal = openModal;
var closeModal = (0, _fluxActions.createAction)(InteractionActionTypes.CLOSE_MODAL);
exports.closeModal = closeModal;